// slider-universities.js
import { initApproveUniversityList } from "../swiper/swiper";

const dataPrefix = 'data-slider-universities';
const $container = document.querySelector(`[${dataPrefix}]`);

if ($container) {
    sliderUniversities({ $container });
}

export function sliderUniversities({ $container }) {
    const loader = $container.querySelector(`[${dataPrefix}-loader]`);
    const sliderEl = $container.querySelector(`[${dataPrefix}-slider]`);

    // safety: если чего-то нет — просто инициализируем как раньше
    if (!sliderEl) {
        initApproveUniversityList('swiper-universities');
        if (loader) loader.style.display = 'none';
        return;
    }

    const imgs = Array.from(sliderEl.querySelectorAll('img'));
    let remaining = imgs.length;
    const TIMEOUT = 5000; // ms

    function showSliderAndInit() {
        // инициализируем swiper и вернём инстанс
        const swiper = initApproveUniversityList('swiper-universities');

        // скрываем лоадер, показываем слайдер
        if (loader) {
            loader.classList.add('is-hidden');
            loader.setAttribute('aria-hidden', 'true');
        }
        sliderEl.classList.remove('is-hidden');
        sliderEl.removeAttribute('aria-hidden');

        // обновим Swiper на всякий случай (пересчёт размеров)
        if (swiper && typeof swiper.update === 'function') {
            // небольшой таймаут чтобы DOM отрисовался
            setTimeout(() => swiper.update(), 50);
        }
    }

    if (remaining === 0) {
        // нет изображений — инициализируем почти сразу
        setTimeout(showSliderAndInit, 50);
        return;
    }

    const timer = setTimeout(() => {
        // таймаут — всё равно запускаем
        showSliderAndInit();
    }, TIMEOUT);

    // обработчики загрузки/ошибки
    imgs.forEach(img => {
        if (img.complete) {
            remaining--;
        } else {
            img.addEventListener('load', () => {
                remaining--;
                if (remaining <= 0) {
                    clearTimeout(timer);
                    showSliderAndInit();
                }
            }, { once: true });

            img.addEventListener('error', () => {
                remaining--;
                if (remaining <= 0) {
                    clearTimeout(timer);
                    showSliderAndInit();
                }
            }, { once: true });
        }
    });

    if (remaining <= 0) {
        clearTimeout(timer);
        showSliderAndInit();
    }
}
